import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InfraEntities } from "../InfraEntities";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";

interface ContainerListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class ContainerListPage extends Component<ContainerListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.container(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}